

const $ = jQuery.noConflict();

export const menuDropdown = (() => {
    const menuItem = $('.main-header .menu .menu-item-has-children > a');
    const subMenu = $('.main-header .menu .menu-item-has-children .sub-menu');

    subMenu.each((i, target) => {
        const that = $(target);
        //that.append(that.siblings('.menu-title-template'));
    });

    menuItem
        .mouseenter((e) => {
            const that = $(e.target);
            const submenu = that.next('ul');
            const sHeight = submenu.outerHeight();
            menuItem.removeClass('active');
            that.addClass('active');
            $('#menuApla').css({
                height: sHeight + 140
            });
            $('#menuApla').fadeIn();
        })
        .mouseleave(() => {
            const that = $(e.target);
            const submenu = that.next('ul');
            that.removeClass('active');
            $('#menuApla').fadeOut();
            //ScreenLock.unlock();
        });

    // menuItem.on('click', (e) => {
    // 	const that = $(e.target);
    // 	const submenu = that.next('ul');
    // 	const sHeight = submenu.outerHeight();
    // 	console.log(sHeight);
    // 	e.preventDefault();
    // 	if (that.hasClass('active')) {
    // 		that.removeClass('active');
    // 		$('#menuApla').fadeOut();
    // 		ScreenLock.unlock();
    // 	} else {
    // 		menuItem.removeClass('active');
    // 		that.addClass('active');
    // 		$('#menuApla').css({
    // 			height: sHeight + 140
    // 		});
    // 		$('#menuApla').fadeIn();
    // 		//ScreenLock.lock();
    // 	}
    // });

    $('#mainHeader').mouseleave(() => {
        menuItem.removeClass('active');
        $('#menuApla').fadeOut();

        //ScreenLock.unlock();
    });
});
